'use client';

import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import { queryAdminTemplate } from '@/services/template';

import { SendType } from '@/types';

import { TemplatePage } from '../components/TemplatePage';

export default function Page(props: any) {
  const { id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    if (id) {
      queryAdminTemplate(id).then((res) => {
        const { contentHtml, fieldsStr, signerFieldsStr, tags, collectionId } = res || {};
        setData({
          addFieldsData: {
            html: contentHtml,
            fields: (fieldsStr && JSON.parse(fieldsStr)) || [],
            signers: (signerFieldsStr && JSON.parse(signerFieldsStr)) || [],
            contractType: tags === SendType.invite ? undefined : tags
          },
          hasCollection: !!collectionId,
          ...res
        });
      });
    }
  }, [id]);
  return <TemplatePage {...props} data={data} />;
}
